import styled from 'styled-components'
import { ReviewBadge } from '@velasca/ui/review-badge'

export const ApparelCard = styled.div`
  max-width: 35rem;
  width: 100%;
  text-align: center;

  &.dynamic-size {
    min-width: 23rem;
    width: 27vh;
  }

  span {
    line-height: 2.2rem;
  }
`

export const Image = styled.div`
  .react-loading-skeleton {
    aspect-ratio: 4/5;

    .safari-lower-than-15 & {
      padding-top: 125%;
    }
  }
`

export const Title = styled.div`
  margin: 1rem 0 0 0;

  .react-loading-skeleton {
    height: 3rem;
    width: 70%;
    margin-bottom: 1rem;
  }

  ${ApparelCard}.xs & {
    margin: 0.5rem 0;

    .react-loading-skeleton {
      height: 2rem;
      width: 80%;
    }

    @media (min-width: 768px) {
      margin-bottom: 1rem;

      .react-loading-skeleton {
        height: 2.2rem;
        width: 65%;
      }
    }
  }
`

export const ProductReviewBadge = styled(ReviewBadge)`
  margin-bottom: 1rem;
  justify-content: center;
`

export const ProductType = styled.div`
  margin-bottom: 1rem;

  .react-loading-skeleton {
    width: 50%;
    height: 1.6rem;
  }

  ${ApparelCard}.xs & {
    .react-loading-skeleton {
      width: 50%;
      height: 3rem;
    }

    @media (min-width: 768px) {
      .react-loading-skeleton {
        width: 70%;
        height: 1.5rem;
      }
    }
  }

  ${ApparelCard}.lg & {
  }
`

export const Season = styled.div`
  margin-bottom: 1rem;

  .react-loading-skeleton {
    width: 65%;
    height: 1.6rem;
  }

  ${ApparelCard}.xs & {
    .react-loading-skeleton {
      width: 50%;
      height: 3rem;
    }

    @media (min-width: 768px) {
      .react-loading-skeleton {
        width: 70%;
        height: 1rem;
      }
    }
  }

  ${ApparelCard}.lg & {
  }
`

export const Description = styled.div`
  margin-bottom: 1.5rem;
  .react-loading-skeleton {
    height: 1.5rem;
  }

  .long-desc {
    display: none;
  }

  ${ApparelCard}.xs & {
    .react-loading-skeleton {
      height: 1.5rem;
    }

    .long-desc {
      @media (max-width: 767px) {
        display: block;
      }
    }
  }

  ${ApparelCard}.lg & {
  }
`

export const Price = styled.div`
  margin-bottom: 1.5rem;

  .react-loading-skeleton {
    width: 20%;
    height: 2.5rem;
  }

  ${ApparelCard}.xs & {
    .react-loading-skeleton {
      width: 25%;
      height: 1.5rem;
    }
  }

  ${ApparelCard}.lg & {
  }
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.colors.disabled};
  margin: 0.8rem auto;

  @media screen and (min-width: 768px) {
    margin: 1rem auto;
  }

  ${ApparelCard}.xs &, ${ApparelCard}.lg & {
    margin: 0.3rem auto 0.6rem;

    @media screen and (min-width: 768px) {
      width: 65%;
    }
  }
`
